/* eslint-disable */
import { smartAppBanner } from "@JS/classic/ocmSettings";

function init() {
	if (smartAppBanner.enabled) {
		new SmartBanner({
			daysHidden: smartAppBanner.daysHidden || 7, // days to hide banner after close button is clicked (defaults to 15)
			daysReminder: smartAppBanner.daysHidden || 90, // days to hide banner after view button is clicked (defaults to 90)
			// appStoreLanguage: 'de', // language code for the App Store (defaults to user's browser language)
			title: "Outletcity Metzingen",
			author: "Holy AG",
			translations: ["en", "de"],
			button: { en: "View", de: "Zur App" },
			// force: 'ios', // Uncomment for platform emulation
			// theme: '', // put platform type ('ios', 'android', etc.) here to force single theme on all devices
			icon: "/_ui/responsive/common/images/smart-app-banner/app-icon.svg", // full path to icon image if not using website icon image
			store: {
				ios: { en: "Free for iOS", de: "Kostenlos für iOS" },
				android: { en: "Free for Android", de: "Kostenlos für Android" },
			},
		});
	}
}

export { init };
